import { render, staticRenderFns } from "./GetCoordinates.vue?vue&type=template&id=a129c270&"
import script from "./GetCoordinates.vue?vue&type=script&lang=js&"
export * from "./GetCoordinates.vue?vue&type=script&lang=js&"
import style0 from "./GetCoordinates.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports